<p-toast position="top-right"></p-toast>
<div class="bank-details-modal">
  <h2 mat-dialog-title>Update Bank Account Details</h2>
  <div mat-dialog-content>
    <form [formGroup]="bankForm" (ngSubmit)="onSubmit()">
      <div class="p-field">
        <label for="account_number">Account Number*</label>
        <input
          pInputText
          id="account_number"
          formControlName="account_number"
          type="text"
          class="form-control w-100"
        />
        <small
          class="p-error"
          *ngIf="
            bankForm.get('account_number')?.invalid &&
            bankForm.get('account_number')?.touched
          "
        >
          Account number is required
        </small>
      </div>

      <div class="p-field">
        <label for="holder_name">Account Holder Name*</label>
        <input
          pInputText
          id="holder_name"
          formControlName="holder_name"
          type="text"
          class="form-control w-100"
        />
        <small
          class="p-error"
          *ngIf="
            bankForm.get('holder_name')?.invalid &&
            bankForm.get('holder_name')?.touched
          "
        >
          Account holder name is required
        </small>
      </div>

      <div class="p-field">
        <label for="ifsc">IFSC Code*</label>
        <div class="p-inputgroup">
          <input
            pInputText
            id="ifsc"
            formControlName="ifsc"
            type="text"
            class="form-control"
            placeholder="e.g. SBIN0001394"
          />
          <span class="p-inputgroup-addon">
            <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>
            <i
              *ngIf="!loading && isIfscValid && bankForm.get('ifsc')?.valid"
              class="pi pi-check"
              style="color: green"
            ></i>
            <i
              *ngIf="!loading && !isIfscValid"
              class="pi pi-times"
              style="color: red"
            ></i>
          </span>
        </div>
        <small
          class="p-error"
          *ngIf="bankForm.get('ifsc')?.invalid && bankForm.get('ifsc')?.touched"
        >
          Valid IFSC code is required (e.g. SBIN0001394)
        </small>
      </div>

      <div class="p-field">
        <label for="bank_name">Bank Name*</label>
        <input
          pInputText
          id="bank_name"
          formControlName="bank_name"
          type="text"
          class="form-control w-100"
          [readonly]="true"
        />
        <small
          class="p-error"
          *ngIf="
            bankForm.get('bank_name')?.invalid &&
            bankForm.get('bank_name')?.touched
          "
        >
          Bank name is required
        </small>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button
      pButton
      type="button"
      label="Cancel"
      (click)="onCancel()"
      class="p-button-secondary"
    ></button>
    <button
      pButton
      type="button"
      label="Update"
      [disabled]="bankForm.invalid || !isIfscValid || loading"
      (click)="onSubmit()"
      class="p-button-primary"
      [loading]="loading"
    ></button>
  </div>
</div>
